import React, { lazy, Suspense } from 'react'
import { Button, Separator, useOverlay, Card, H2, Paragraph, colors } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { ContentUpload } from '@fs/zion-icon'
import { useUploadTree } from '../../../services/useUploadTree'

const UploadTreeOverlay = lazy(() => import('../import-page/UploadTreeOverlay'))

function UploadGedcomCard() {
  const [t] = useTranslation()
  const overlay = useOverlay()
  const { maxTrees, disableCreateTreeButton, refetchData } = useUploadTree()

  return (
    <Card margins="xs" edges="border" backgroundColor={colors.gray00}>
      <H2 size="H5">{t('tree-import.manage-trees.upload-heading')}</H2>
      <Separator size="xs" />
      <Paragraph growY size="sm">
        {t('tree-import.manage-trees.upload-description')}
      </Paragraph>
      <Separator size="xs" />
      <Button
        disabled={disableCreateTreeButton}
        disabledDescription={
          maxTrees ? t('tree-import.create-tree-max-groups.error', { maxGroups: maxTrees }) : undefined
        }
        Icon={ContentUpload}
        data-testid="upload-gedcom-button.upload-gedcom.button"
        onClick={overlay.handleClick}
        linkName="Upload Gedcom Button"
      >
        {t('tree-import.create-files.button')}
      </Button>

      <Suspense fallback="">
        {(overlay.isOpen || overlay.transitioning) && <UploadTreeOverlay overlay={overlay} onSuccess={refetchData} />}
      </Suspense>
    </Card>
  )
}

export default UploadGedcomCard
